import React from 'react';

import { PostHogProvider } from 'posthog-js/react';
import { createRoot } from 'react-dom/client';

import { init as analyticsInit } from '@/services/analytics';

import '@/features/markets/widgets/register';

import App from './App';
import '../index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);
const strictMode = import.meta.env.DEV && import.meta.env.VITE_DISABLE_STRICT_MODE !== 'true';
const app = strictMode ? (
  <React.StrictMode>
    <App />
  </React.StrictMode>
) : (
  <App />
);

const renderApp = () => {
  const posthogClient = analyticsInit();

  if (posthogClient) {
    root.render(<PostHogProvider client={posthogClient}>{app}</PostHogProvider>);
  } else {
    root.render(app);
  }
};

if (import.meta.env.DEV) {
  const { scan } = await import('react-scan');
  scan({
    enabled: true
  });

  const isMswEnabled = import.meta.env.VITE_ENABLE_MSW?.toLowerCase() === 'true';

  if (isMswEnabled) {
    const { worker } = await import('../../mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  renderApp();
} else {
  renderApp();
}
